var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpbu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-5 -5 60.00 60.00",
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 60,
    height: 60,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.102 10.08c.549-.549 1.322-1.146 2.111-1.866l.729-.611-1.987-2.23-.649.607c-2.746 2.495-4.398 4.003-5.205 7.094-.801 3.073-.833 6.184-.749 9.092.088 2.998.201 4.976 1.039 7.182l.316.813c.804 2.023 2.021 5.079 2.021 9.01 0 4.749-1.924 7.158-5.718 7.158-3.452 0-5.314-2.304-5.532-6.856-.099-2.017.467-4.507 1.062-7.138.503-2.221 1.021-4.519 1.276-6.958.282-2.689-.071-4.611-1.104-5.765-1.326-1.481-3.367-1.612-5.165-1.612h-.547v-13.861c0-1.2-.871-2.139-2.064-2.139h-20.641c-1.191 0-2.295.939-2.295 2.139v43.861h25v-27h.548c1.23 0 2.504.138 2.937.621.232.26.588 1.102.353 3.373-.237 2.264-.739 4.503-1.223 6.636-.641 2.839-1.249 5.539-1.129 7.973.295 6.179 3.404 9.73 8.524 9.73 5.457 0 8.715-3.798 8.715-10.168 0-4.509-1.395-8.022-2.232-10.127l-.302-.767c-.602-1.589-.737-3.062-.82-5.632.963-.022 2.129-.045 2.653-.045 1.199 0 1.802-.703 2.059-1.921.15-.71-.082-1.641-.082-3.331v-.448c-.001-4.467-.684-5.743-1.899-6.814zm-21.102 8.92h-19v-13h19v13zm20-1.654c0 .873.23 1.708.201 2.239-.598.009-1.286.025-1.986.041.026-1.929.24-3.893.733-5.784.134-.504.094-.948.296-1.362.533.513.756 1.282.756 4.416v.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpbu);
export default __webpack_public_path__ + "static/media/spbu.359c30399a7484387adb1d8009ae9ea3.svg";
export { ForwardRef as ReactComponent };